import React from 'react';
import { Linkgroup } from '../../components/Header/Linkgroup';
import Typography from '@mui/material/Typography';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import AuthCard from '../../components/Cards/AuthCard';


export default function EmailPwCard() {

    return (

      <AuthCard 
    
      icon = { <MarkEmailUnreadIcon color= 'text.brown'/> }
      topic = 'Action required'
      content = {<>

            <Typography variant="h4" color='text.brown' textAlign="center" gutterBottom sx={{mt: 4, mb:4, fontWeight: '500', }}> 
            An email was sent to your registered email address to reset password<br />
              </Typography>

            <Typography variant="h4" color='text.brown' textAlign="center" gutterBottom sx={{mt: 4, mb:4, fontWeight: '500', }}> 
            After entering new passwords <br />
            you will be able to log in with new passwords.   </Typography>

            <Linkgroup destination='/Login' button_name='Sign In' />

          </> 
        }/>
  )
}